<template>
  <div class="leftSection">
    <div
      v-if="hasPageTitle"
      class="header-title wrapper-content__main font-size__large font-weight__bold"
    >
      {{ pageTitle }}
    </div>

    <div class="tagFilter">
      <VuePerfectScrollbar class="scroll-area-filter" :settings="settings">
        <template v-for="(status, $itemIndex) in allStatuses">
          <span
            v-bind:key="'sp_' + $itemIndex"
            :class="[
              currentStatus.value === status.value ? 'active' : '',
              'status-item'
            ]"
            @click="doFilter(status, $itemIndex)"
          >
            <span>&nbsp;{{ status.name }}&nbsp;</span>
          </span>
        </template>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "filter-by-status-header-2",
  props: ["statuses", "pageTitle", "initialStatusValue"],
  components: {
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar")
  },

  created() {
    this.initStatus();
  },

  watch: {
    initialStatusValue(newVaue, oldValue) {
      this.initStatus();
    },

    statuses(newValue, oldValue) {
      this.initStatus();
    }
  },

  data() {
    return {
      allStatuses: [],
      currentIndex: 0,
      currentStatus: null,
      settings: { maxScrollbarLength: 750 }
    };
  },

  computed: {
    hasPageTitle() {
      return !!this.pageTitle;
    }
  },

  methods: {
    doFilter(status, index) {
      if (this.currentStatus.value !== status.value) {
        this.currentStatus = status;
        this.currentIndex = index;
        this.$emit("doFilter", status, index);
      }
    },

    initStatus() {
      if (typeof this.statuses !== "undefined") {
        this.allStatuses = this.statuses;
      } else {
        this.allStatuses = [];
      }

      let initIndex = 0;
      let initStatus = null;

      for (let i = 0; i < this.allStatuses.length; i++) {
        if (this.allStatuses[i].value === this.initialStatusValue) {
          initIndex = i;
          initStatus = this.allStatuses[i];
          break;
        }
      }

      this.currentIndex = initIndex;
      this.currentStatus = initStatus;
    }
  }
};
</script>

<style scoped>
.leftSection {
  z-index: 10;
}

.scroll-area-filter {
  max-width: 100%;
  height: 100%;
  position: relative;
  margin: auto;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/components/filter-by-status-header.vue